import { useDispatch, useSelector } from 'react-redux';
import { diagnosticDelineationChangedSelector } from '../../delineation/selectors/delineation.selectors';
import { saveWaves } from '../../wave/thunks/save-waves.thunk';
import { currentEcgIdSelector } from '../selectors/ecg-count.selectors';
import { ecgIdSelector } from '../selectors/ecg.selectors';
import { CustomButton } from './CustomButton';
import * as ecgCountActions from '../actions/ecg-count.actions';
import { saveDiagnostic } from '../../diagnostic/thunks/save-diagnostic.thunk';
import { trackSingleSaveButton } from '../../analytics/thunks/trackSingleSaveButton.thunk';
import { getLayoutValueSelector } from '../../layout/selectors/layout.selectors';
import { displayAutoLabelsToAssess } from '../../autoLabels/thunks/display-auto-labels-to-assess.thunk';
import * as autoLabelsActions from '../../autoLabels/actions/auto-labels.actions';
import { needToAssessSelector } from '../../autoLabels/selectors/auto-labels.selectors';

interface Props {
  allowDiagnosticSave?: boolean;
  allowDelineationSave?: boolean;
}

export const SaveDiagnosticDelineation: React.FC<Props> = ({
  allowDelineationSave = true,
  allowDiagnosticSave = true,
}) => {
  const dispatch = useDispatch();
  const changed = useSelector(diagnosticDelineationChangedSelector);
  const counterEcgId = useSelector(currentEcgIdSelector);
  const ecgId = useSelector(ecgIdSelector);
  const withSuggestionsPanel = useSelector(
    getLayoutValueSelector('withSuggestionsPanel'),
  );
  const isForbidToSave = useSelector(needToAssessSelector);

  const save = async () => {
    dispatch(trackSingleSaveButton());

    if (counterEcgId !== ecgId && ecgId != null) {
      dispatch(ecgCountActions.increment({ ecgId }));
    }
    if (withSuggestionsPanel) {
      const needToAssessLabels = dispatch(
        displayAutoLabelsToAssess(),
      ) as unknown as boolean;
      if (needToAssessLabels) return;
    }
    if (allowDiagnosticSave) {
      await dispatch(saveDiagnostic());
    }
    if (allowDelineationSave) {
      await dispatch(saveWaves());
    }
    dispatch(
      autoLabelsActions.setAssessmentStatus({
        status: 'none',
        meta: { history: false },
      }),
    );
  };

  return (
    <CustomButton
      dataTestId='save-both-btn'
      disabled={!changed || isForbidToSave}
      onClick={save}
    >
      Save
    </CustomButton>
  );
};
